import { Component, Emit, Prop, Provide, Ref, Vue } from 'vue-property-decorator'
import ConfigurationLocalAssaysResultsModalBasicForm
    from '@/modules/configurationModule/detail/local-assays/results/components/modal-basic-form/configuration-local-assays-results-modal-basic-form.vue'
import { BModal } from 'bootstrap-vue'
import {
    ConfigurationPossibleAssayResultPatchInBatchRequest,
    ConfigurationPossibleAssayResultRequest,
    ConfigurationPossibleAssayResultResponse
} from '@/modules/configurationModule/detail/local-assays/results/services/configuration-possible-assay-result/configuration-possible-assay-result.dto'
import {
    ConfigurationLocalAssaysResultsModalState,
    initialConfigurationLocalAssaysResultsModalState
} from '@/modules/configurationModule/detail/local-assays/results/components/modal/configuration-local-assays-results-modal.model'

@Component({
    components: {
        ConfigurationLocalAssaysResultsModalBasicForm
    }
})
export default class ConfigurationLocalAssaysResultsModal extends Vue {
    @Ref() readonly configurationLocalAssaysResultsModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Provide() externalValidator = this.$validator

    @Emit()
    create(): ConfigurationPossibleAssayResultRequest {
        return {
            active: this.state.possibleAssayResult.active!,
            code: this.state.possibleAssayResult.code!,
            nameTranslations: this.state.possibleAssayResult.nameTranslations!.map(nameTranslation => ({
                languageId: nameTranslation.language.id,
                value: nameTranslation.value,
                notes: nameTranslation.notes
            }))
        }
    }

    @Emit()
    update(): ConfigurationPossibleAssayResultPatchInBatchRequest {
        return {
            id: this.state.possibleAssayResult.id!,
            active: this.state.possibleAssayResult.active,
            code: this.state.possibleAssayResult.code,
            nameTranslations: this.state.possibleAssayResult.nameTranslations?.map(nameTranslation => ({
                languageId: nameTranslation.language.id,
                value: nameTranslation.value,
                notes: nameTranslation.notes
            }))
        }
    }

    state: ConfigurationLocalAssaysResultsModalState

    private get _updateMode(): boolean {
        return !!this.state.possibleAssayResult?.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    constructor() {
        super()
        this.state = initialConfigurationLocalAssaysResultsModalState()
    }

    async show(possibleAssayResult?: ConfigurationPossibleAssayResultResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationLocalAssaysResultsModalState()
        if (possibleAssayResult) {
            this.state.possibleAssayResult = { ...possibleAssayResult }
        }

        this.configurationLocalAssaysResultsModal.show()
    }

    hide(): void {
        this.configurationLocalAssaysResultsModal.hide()
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.state.possibleAssayResult) {
                if (this._updateMode) {
                    this.update() // emits an event
                } else {
                    this.create() // emits an event
                }
            }

            this.hide()
        }
    }
}
